<template>
  <div>
    <el-dialog
      v-for="(item, idx) in list"
      :key="idx"
      title="提示"
      :visible.sync="item.visible"
      width="350px"
    >
      <div class="rectify-notice">
        <div>您有一条绩效整改待提交：</div>
        <div>{{item.message}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="viewDetail(item)">查看详情</el-button>
        <el-button @click="item.visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { lspRectificationPlanPopup } from "../../api/notificationWarn.js";

export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 3000);
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {},
  methods: {
    init() {
      const rectifyNotice = sessionStorage.getItem("rectifyNotice");
      if (!rectifyNotice) {
        sessionStorage.setItem("rectifyNotice", true);
        lspRectificationPlanPopup().then((res) => {
          if (res && +res.code === 0) {
        //     res.data = [
        // {
        //     "month": "2024-01",
        //     "rectificationPlanCode": "821398123981298398",
        //     "message": "撒看见大家卡仕达卡斯柯觉得安康就是多久啊可是看"
        // },
        // {
        //     "month": "2024-02",
        //     "rectificationPlanCode": "8546948583489349494",
        //     "message": "ksdkasdkasldaldkaksldklasdlka"
        // }
        // ]
            this.list = res.data.map(v => {
                return {
                    ...v,
                    visible: true
                }
            })
          }
        });
      }
    },
    viewDetail(item) {
      this.list.forEach((v) => {
        v.visible = false;
      });
      this.$router.push(`/lsrm/performRectify?month=${item.month}&rectificationPlanCode=${item.rectificationPlanCode}&performanceDimension=${item.performanceDimension}`);
    },
  },
};
</script>

<style scoped lang="less">
</style>
